/* eslint-disable */

// Generated by CoffeeScript 2.5.1
(function() {
  //###################################
  //#   CLASSES FOR REUSABLE GRAPHS  ##
  //###################################
  var BaseGraph, GraphModule, Tooltip, colorbrewer, d3, d3Tip, moduleKeywords, ref,
    indexOf = [].indexOf,
    boundMethodCheck = function(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new Error('Bound instance method accessed before binding'); } };

  Tooltip = require("imports/Tooltip");

  d3 = require("d3");

  d3Tip = require("d3-tip");

  d3.tip = d3Tip;

  colorbrewer = require("app/static/js/libs/colorbrewer.v1.min.js");

  moduleKeywords = ['extended', 'included'];

  GraphModule = class GraphModule {
    /* code to enable mixins */
    // adds static properties
    static extend(obj) {
      var key, ref, value;
      for (key in obj) {
        value = obj[key];
        if (indexOf.call(moduleKeywords, key) < 0) {
          this[key] = value;
        }
      }
      if ((ref = obj.extended) != null) {
        ref.apply(this);
      }
      return this;
    }

    // adds instance properties
    static include(obj) {
      var key, ref, value;
      for (key in obj) {
        value = obj[key];
        if (indexOf.call(moduleKeywords, key) < 0) {
          // Assign properties to the prototype
          this.prototype[key] = value;
        }
      }
      if ((ref = obj.included) != null) {
        ref.apply(this);
      }
      return this;
    }

  };

  BaseGraph = (function() {
    class BaseGraph extends GraphModule {
      constructor() {
        super();
        this.data = [];
        this.stat_list = [];
        this.specificVarsInit();
        this.svg = d3.select(this.selector).append("svg").attr("id", this.graph_id).attr("width", this.width + this.margin.left + this.margin.right).attr("height", this.height + this.margin.top + this.margin.bottom).append("g").classed(`transform-g-${this.graph_id}`, true).attr("transform", "translate(" + this.margin.left + "," + this.margin.top + ")").attr("xmlns", "http://www.w3.org/2000/svg");
        this.clip = this.svg.append("defs").append("svg:clipPath").attr("id", `clip-${this.graph_id}`).append("svg:rect").attr("id", "clip-rect").attr("x", "0").attr("y", "0").attr("width", this.width).attr("height", this.height);
        this.chartBody = this.svg.append("g").attr("clip-path", `url(#clip-${this.graph_id})`).classed(`body-${this.graph_id}`, true);
        this.background = this.chartBody.append('svg:rect').attr("id", `body-inner-${this.graph_id}`).attr("class", "body-inner").attr('width', this.width).attr('height', this.height).attr('fill', this.background_color ? this.background_color : 'white');
        this.legend_elements_g = d3.select(`.transform-g-${this.graph_id}`).append("g").attr("class", `legend-${this.graph_id}`);
        this.x_axis_g = d3.select(`.transform-g-${this.graph_id}`).append("g").attr("class", `x axis x-axis-${this.graph_id}`).attr("transform", "translate(0," + this.height + ")").attr("transform", "translate(0," + this.height + ")");
        this.y_axis_g = d3.select(`.transform-g-${this.graph_id}`).append("g").attr("class", `y axis y-axis-${this.graph_id}`);
      }

      format_number(raw_number) {
        var number, value;
        number = raw_number * 1;
        number = +number.toFixed(1);
        if (number < 10000) {
          return value = number.toString().substr(0, 4);
        } else if (number < 1000000) {
          number = number / 1000;
          return value = number.toString().substr(0, 4) + "K";
        } else if (number < 1000000000) {
          number = number / 1000000;
          return value = number.toString().substr(0, 4) + "M";
        } else if (number > 1000000000) {
          number = number / 1000000000;
          return value = number.toString().substr(0, 4) + "B";
        }
      }

      showDetails() {
        console.log("show details");
      }

      hideDetails() {
        console.log("hideDetails");
      }

      specificVarsInit() {}

      update() {}

      clearGraphandUpdate() {}

      updateLegend() {}

      clearLegend() {}

    };

    //include generic mixins
    BaseGraph.include(basicInteractivity);

    BaseGraph.include(genericControlElements);

    return BaseGraph;

  }).call(this);

  ref = window.BaseLineGraph = (function() {
    var DEFAULT_X_AXIS_PADDING;

    class BaseLineGraph extends BaseGraph {
      constructor(selector1, margin, width, height, graph_id, saveTrendlineToStore, getSavedLines) {
        super();
        this.getYAxisPadding = this.getYAxisPadding.bind(this);
        this.getXAxisPadding = this.getXAxisPadding.bind(this);
        this.selector = selector1;
        this.margin = margin;
        this.width = width;
        this.height = height;
        this.graph_id = graph_id;
        this.saveTrendlineToStore = saveTrendlineToStore;
        this.getSavedLines = getSavedLines;
        // horrendous hack so that there's enough colors
        this.colors = ["#503ABD", "#503ABD", "#95a5a6", "#2caaff", "#503ABD", "#95a5a6", "#503ABD", "#2caaff", "#503ABD", "#95a5a6", "#503ABD", "#2caaff", "#503ABD", "#95a5a6", "#503ABD", "#2caaff", "#503ABD", "#95a5a6", "#503ABD", "#2caaff", "#503ABD", "#95a5a6", "#503ABD", "#2caaff", "#503ABD", "#95a5a6", "#503ABD", "#2caaff", "#503ABD", "#95a5a6", "#503ABD", "#2caaff", "#503ABD", "#95a5a6", "#503ABD", "#2caaff"];
        this.line = d3.svg.line().x(function(d) {
          return this.x_scale(d.date);
        }).y(function(d) {
          return this.y_scale(d.statistic);
        });
        this.statline_g = d3.select(`.transform-g-${this.graph_id}`).append("g");
        this.dots_g = d3.select(`.transform-g-${this.graph_id}`).append("g");
        this.y_scale = d3.scale.linear().range([this.height, 0]);
        this.x_scale = d3.scale.ordinal().rangePoints([0, this.width], 0.5);
        this.line_range = d3.scale.ordinal().range([]);
        this.monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        this.update();
      }

      getYAxisPadding() {
        var _self, bbox, i, k, len, maxWidthYaxisTest, ref1;
        boundMethodCheck(this, ref);
        _self = this;
        this.testYText = d3.select(`.transform-g-${this.graph_id}`);
        this.testYText.append("text").text(this.format_number(this.max)).classed('test-y-axis-text', true).attr('text-anchor', 'end').attr('visibility', 'hidden');
        maxWidthYaxisTest = 0;
        ref1 = $(".test-y-axis-text");
        for (k = 0, len = ref1.length; k < len; k++) {
          i = ref1[k];
          bbox = i.getBBox();
          if (bbox.width > maxWidthYaxisTest) {
            maxWidthYaxisTest = bbox.width;
          }
        }
        $(".test-y-axis-text").remove();
        return maxWidthYaxisTest;
      }

      getXAxisPadding() {
        var bbox, i, k, l, len, len1, maxHeightXAxisText, ref1, ref2, x_axis_datum;
        boundMethodCheck(this, ref);
        // check padding from the bottom based on X-Axis Labels
        this.xAxisRotateCheck = false;
        // if know x-axis variable set, then return the default padding
        if (!this.x_axis_var) {
          return DEFAULT_X_AXIS_PADDING;
        }
        ref1 = this.data;
        for (k = 0, len = ref1.length; k < len; k++) {
          i = ref1[k];
          if (this.x_axis_var_time_check) {
            x_axis_datum = this.monthNames[i[this.x_axis_var].getMonth()];
          } else {
            x_axis_datum = i[this.x_axis_var].toString();
          }
          if ((x_axis_datum != null ? x_axis_datum.length : void 0) >= 3) {
            this.xAxisRotateCheck = true;
          }
        }
        this.testXTest = this.svg.selectAll("test-x-axis-text").data(this.data);
        this.testXTest.enter().append('text').attr('x', 100).text((d, i) => {
          if (this.x_axis_var_time_check) {
            return this.monthNames[d[this.x_axis_var].getMonth()];
          } else {
            return d[this.x_axis_var].toString();
          }
        }).classed('test-x-axis-text', true).attr('text-anchor', 'end').attr('fill', 'white').attr('visibility', 'hidden');
        if (this.xAxisRotateCheck) {
          d3.selectAll(".test-x-axis-text").attr("transform", "rotate(-45)").style("text-anchor", "end").attr("dy", ".75em").attr("dx", "-.75em");
        }
        maxHeightXAxisText = 0;
        ref2 = $(".test-x-axis-text");
        for (l = 0, len1 = ref2.length; l < len1; l++) {
          i = ref2[l];
          bbox = i.getBBox();
          if (bbox.height > maxHeightXAxisText) {
            maxHeightXAxisText = bbox.height;
          }
        }
        // remove test text
        $(".test-x-axis-text").remove();
        return maxHeightXAxisText + DEFAULT_X_AXIS_PADDING;
      }

      update() {
        var _self, ordinal_domain, statsTemp;
        _self = this;
        if (this.getSavedLines().length) {
          // set data
          this.data = this.getSavedLines();
          // reset stats for current count
          if (this.stats && this.stats[0]) {
            this.stats[0].values = this.data.map(function(stat) {
              return {
                date: stat.date,
                statistic: +stat.count
              };
            });
          }
        }
        this.keys = d3.keys(this.data[0]).filter(function(key) {
          if (key !== this.x_axis_var) {
            return key;
          }
        });
        this.line_range.domain(d3.keys(this.data[0]).filter(function(key) {
          if (key !== this.x_axis_var) {
            return key;
          }
        }));
        statsTemp = this.line_range.domain().map((name) => {
          var values;
          values = this.data.map(function(d) {
            return {
              date: d[this.x_axis_var],
              statistic: +d[name]
            };
          });
          return {
            name: name,
            values: values
          };
        });
        // save stats to new list to avoid mutation bugs
        this.stats = Object.assign([], statsTemp);
        if (!this.max) {
          this.max = 1;
        }
        this.max = (this.stats && this.stats[0]) ? d3.max(this.stats, (c, i) => {
          var filteredValues;
          filteredValues = _self.restrictObjByDate(c.values);
          if (!filteredValues.length) {
            this.stats[i].values = [
              {
                date: this.startDate,
                statistic: 0
              },
              {
                date: this.endDate,
                statistic: 0
              }
            ];
            return this.max;
          } else {
            // otherwise, set stats values to the filtered values
            this.stats[i].values = filteredValues;
          }
          // get the max
          if (_self.isInArray(this.stats[0].name, _self.stat_list)) {
            return d3.max(filteredValues, function(v) {
              return v.statistic;
            });
          }
        }) : this.max;
        this.max = this.max * 1.1; //extra space at top of graphs
        this.yAxisPadding = this.getYAxisPadding();
        this.xAxisPadding = this.getXAxisPadding();
        // set startDate and endDate to be the first and last stat values so that we force graph to show data across entire axis
        if (this.stats && this.stats[0]) {
          this.startDate = this.stats[0].values[0].date;
          this.endDate = this.stats[0].values[this.stats[0].values.length - 1].date;
        }
        if (this.x_axis_var_time_check) {
          this.x_scale = d3.time.scale().rangeRound([this.yAxisPadding, this.width]);
          this.x_scale.domain([this.startDate, this.endDate]);
        } else {
          this.x_scale = d3.scale.ordinal().rangePoints([this.yAxisPadding, this.width], 0.5);
          ordinal_domain = d3.range(this.startDate, this.endDate);
          ordinal_domain.push(this.endDate);
          this.x_scale.domain(ordinal_domain);
        }
        this.y_scale = d3.scale.linear().range([this.height - this.xAxisPadding, 0]);
        this.y_scale.domain([0, this.max]);
        this.r_scale = d3.scale.linear().range([this.radii_min, this.radii_max]);
        this.r_scale.domain([0, this.max]);
        this.statline = this.statline_g.selectAll(`.statline-${this.graph_id}`).data(this.stats);
        this.statline.enter().append("g").attr("class", `statline-${this.graph_id}`).attr("id", (datum) => {
          return datum.name;
        }).append("path");
        this.statline.attr("class", `statline-${this.graph_id}`).append("path").style("stroke-width", _self.stroke_width ? _self.stroke_width : "2").attr("fill", this.fill_color ? this.fill_color : "none").attr("d", function(d) {
          var vals_restricted_by_date;
          vals_restricted_by_date = _self.restrictObjByDate(d.values);
          return _self.line(vals_restricted_by_date);
        }).style("stroke", function(d, i) {
          if (_self.isInArray(d.name, _self.stat_list)) {
            return _self.colors[i];
          }
        });
        this.dots = this.dots_g.selectAll(".dots").data(this.stats);
        this.dotter = this.dots.enter().append("g").attr("id", `dots-${this.graph_id}`).style("display", function(d) {
          if (_self.dot_check) {
            return "block";
          } else {
            return "none";
          }
        }).attr("fill", function(d, i) {
          if (_self.dot_check) {
            if (_self.dots_fill_color) {
              return _self.dots_fill_color;
            } else {
              return _self.colors[i];
            }
          }
        }).attr("class", "g");
        this.dotter.selectAll("circle").data(function(d) {
          return d.values;
        }).enter().append("circle").attr("stroke", function(d, i, j) {
          return _self.colors[j];
        }).attr("stroke-width", this.dots_stroke_width ? this.dots_stroke_width : 1).attr("r", function(d) {
          return _self.r_scale(d.statistic);
        }).attr("cx", function(d) {
          return _self.x_scale(d.date);
        }).attr("cy", function(d) {
          return _self.y_scale(d.statistic);
        }).transition().delay(function(d, i) {
          return 50 * i;
        });
        this.dotter.selectAll("text").data(function(d) {
          return d.values;
        }).enter().append("text").attr("text-anchor", "middle").attr("x", function(d) {
          return _self.x_scale(d.date);
        }).attr("y", function(d) {
          return _self.y_scale(d.statistic) + 5;
        }).attr("fill", "white").style("font-size", this.text_size).text(function(d) {
          if (_self.text_check) {
            return Math.round(d.statistic * 10) / 10;
          } else {
            return "";
          }
        }).transition().delay(function(d, i) {
          return 50 * i;
        });
        this.x_axis = d3.svg.axis().scale(this.x_scale).orient("bottom");
        this.y_axis = d3.svg.axis().scale(this.y_scale).orient("left").ticks(5);
        this.y_axis.tickFormat(function(d, i) {
          return _self.format_number(d);
        });
        this.y_axis_g.attr("transform", "translate(" + this.yAxisPadding + ",0)");
        this.x_axis_g.attr("transform", "translate(0," + (this.height - this.xAxisPadding) + ")");
        this.y_axis_g.transition().duration(1000).call(this.y_axis);
        return this.x_axis_g.transition().duration(1000).call(this.x_axis);
      }

      clearGraphandUpdate() {
        this.statline.remove();
        this.dots.remove();
        return this.update();
      }

    };

    DEFAULT_X_AXIS_PADDING = 15;

    return BaseLineGraph;

  }).call(this);

  window.BaseAreaGraph = class BaseAreaGraph extends BaseGraph {
    constructor(selector1, margin, width, height, graph_id) {
      super();
      this.selector = selector1;
      this.margin = margin;
      this.width = width;
      this.height = height;
      this.graph_id = graph_id;
      this.colors = d3.scale.linear().range(["#503ABD", "#845ea4"]);
      this.area = d3.svg.area().x(function(d) {
        return this.x_scale(d.date);
      }).y0(function(d) {
        return this.y_scale(d.y0);
      }).y1(function(d) {
        return this.y_scale(d.y0 + d.y);
      });
      this.stack = d3.layout.stack().values(function(d) {
        return d.values;
      });
      this.stacked_lines = [];
      this.stacked_colors = d3.scale.category20();
      this.y_scale = d3.scale.linear().range([this.height, 0]);
      this.statarea_g = d3.select(`.transform-g-${this.graph_id}`).append("g");
      this.update();
    }

    update() {
      var _self, i, inner, max, maxer, ordinal_domain, outer;
      _self = this;
      if (this.stat_list.length > 0) {
        this.stacked_colors.domain(d3.keys(this.data[0]).filter(function(key) {
          if (key !== _self.x_axis_var && _self.isInArray(key, _self.stat_list)) {
            return key;
          }
        }));
        this.stacked_lines = this.stack(this.stacked_colors.domain().map(function(name) {
          return {
            name: name,
            values: _self.data.map(function(d) {
              return {
                date: d[this.x_axis_var],
                y: +d[name]
              };
            })
          };
        }));
        maxer = [];
        i = 0;
        while (i < this.stacked_lines[0].values.length) {
          maxer.push(0);
          i += 1;
        }
        outer = 0;
        while (outer < this.stacked_lines.length) {
          inner = 0;
          while (inner < this.stacked_lines[outer].values.length) {
            maxer[inner] += this.stacked_lines[outer].values[inner].y;
            inner += 1;
          }
          outer += 1;
        }
        max = d3.max(maxer);
      } else {
        max = d3.max(this.stacked_lines, function(c) {
          c.values = restrictObjByDate(c.values);
          if (_self.isInArray(c.name, _self.stat_checker)) {
            return d3.max(c.values, function(v) {
              return v.y;
            });
          }
        });
      }
      this.y_scale.domain([0, max]);
      if (this.x_axis_var_time_check) {
        this.x_scale = d3.time.scale().range([0, this.width]);
        this.x_scale.domain([this.startDate, this.endDate]);
      } else {
        this.x_scale = d3.scale.ordinal().rangePoints([0, this.width]);
        ordinal_domain = d3.range(this.startDate, this.endDate);
        ordinal_domain.push(this.endDate);
        this.x_scale.domain(ordinal_domain);
      }
      this.colors.domain([0, this.stat_list.length - 1]);
      this.statarea = this.statarea_g.selectAll(".statarea").data(this.stacked_lines);
      this.statarea.enter().append("g").append("path");
      this.statarea.append("path").attr("fill", function(d, i) {
        return _self.colors(i);
      }).attr("d", function(d) {
        var vals_restricted_by_date;
        if (_self.isInArray(d.name, _self.stat_list)) {
          vals_restricted_by_date = _self.restrictObjByDate(d.values);
          return _self.area(vals_restricted_by_date);
        }
      }).style("stroke", function(d, i) {
        if (_self.isInArray(d.name, _self.stat_list)) {
          return _self.colors(i);
        }
      });
      this.x_axis = d3.svg.axis().scale(this.x_scale).orient("bottom");
      this.y_axis = d3.svg.axis().scale(this.y_scale).orient("left");
      this.y_axis_g.transition().duration(1000).call(this.y_axis);
      return this.x_axis_g.transition().duration(1000).call(this.x_axis);
    }

    clearGraphandUpdate() {
      this.statarea.remove();
      return this.update();
    }

  };

  window.BaseBarGraph = class BaseBarGraph extends BaseGraph {
    constructor(selector1, margin, width, height, graph_id) {
      super();
      this.selector = selector1;
      this.margin = margin;
      this.width = width;
      this.height = height;
      this.graph_id = graph_id;
      this.grouped = false;
      this.barInit = false;
      this.stack = d3.layout.stack();
      this.x_scale = d3.scale.ordinal().rangeRoundBands([0, this.width], 0.2);
      this.y_scale = d3.scale.linear().range([this.height, 0]);
      this.colors = d3.scale.linear().range(["#845ea4", "#503ABD"]);
      this.transition_name = "transition";
      this.y_axis_label = this.y_axis_g.append("text").attr("transform", "rotate(-90)").attr("y", 6).attr("dy", ".71em").style("text-anchor", "end").style("font-size", "13.5px");
      this.tooltip = Tooltip.default(`${this.graph_id}-tooltip`);
      this.update();
    }

    update() {
      var _self, axis_prettify, i, k, len, m, n, ref1, time_span;
      _self = this;
      console.log("ORIGINAL DATA");
      console.log(this.data);
      this.restrictedData = this.restrictObjByDate(this.data, this.x_axis_var);
      console.log("STAT LIST");
      console.log(this.stat_list);
      console.log("ORIGINAL RESTRICTED DATA");
      console.log(this.restrictedData);
      if (this.stat_list.length > 0) {
        this.barInit = true;
        this.issueAreas = d3.keys(this.restrictedData[0]).filter(function(key) {
          if (key !== this.x_axis_var && _self.isInArray(key, _self.stat_list)) {
            return key;
          }
        });
        console.log("ISSUE AREAS");
        console.log(this.issueAreas);
        this.restrictedData.forEach(function(d) {
          return d.issues = _self.issueAreas.map(function(name) {
            if (typeof d[name] === 'number') {
              return {
                name: name,
                value: +d[name]
              };
            } else {
              return {
                name: name,
                value: 0
              };
            }
          });
        });
        console.log("RESTRICTED DATA");
        console.log(this.restrictedData);
        time_span = [];
        ref1 = this.restrictedData;
        for (k = 0, len = ref1.length; k < len; k++) {
          i = ref1[k];
          time_span.push(i[this.x_axis_var]);
        }
        n = this.issueAreas.length;
        m = this.restrictedData.length;
        if (n > 0) {
          this.layers = this.stack(d3.range(n).map(function(d, i) {
            return _self.bumpLayer(m, i);
          }));
          this.yGroupMax = d3.max(this.layers, function(layer) {
            return d3.max(layer, function(d) {
              return d.y;
            });
          });
          this.yStackMax = d3.max(this.layers, function(layer) {
            return d3.max(layer, function(d) {
              return d.y0 + d.y;
            });
          });
          this.x_scale.domain(d3.range(m));
          this.y_scale.domain([0, this.yStackMax]);
          this.colors.domain([0, n - 1]);
          this.layer = this.svg.selectAll(".layer").data(this.layers).enter().append("g").attr("class", (d, i) => {
            return `layer ${this.stat_list[i]}`;
          }).style("fill", function(d, i) {
            return _self.colors(i);
          });
          this.rect = this.layer.selectAll("rect").data(function(d) {
            return d;
          }).enter().append("rect").attr("x", function(d) {
            return _self.x_scale(d.x);
          }).attr("y", this.height).attr("width", this.x_scale.rangeBand()).attr("height", 0).on("mouseover", function(d, i) {
            return _self.showDetails(d, i, _self, this);
          }).on("mouseout", function(d, i) {
            return _self.hideDetails(d, i, _self, this);
          });
          this.rect.transition().delay(function(d, i) {
            return i * (_self.transition_time ? _self.transition_time : 10);
          }).attr("y", function(d) {
            return _self.y_scale(d.y0 + d.y);
          }).attr("height", function(d) {
            return _self.y_scale(d.y0) - _self.y_scale(d.y0 + d.y);
          });
        }
      } else {
        this.y_scale.domain([]);
      }
      axis_prettify = d3.time.format("%d %b");
      this.x_axis = d3.svg.axis().scale(this.x_scale).orient("bottom");
      this.y_axis = d3.svg.axis().scale(this.y_scale).orient("left").ticks(10);
      this.x_axis.tickFormat(function(d, i) {
        if (typeof time_span[i] === 'number') {
          this.x_axis_var_time_check = false;
          return time_span[i];
        } else {
          this.x_axis_var_time_check = true;
          return axis_prettify(time_span[i]);
        }
      });
      this.y_axis_g.transition().duration(1000).call(this.y_axis);
      if (!this.x_axis_var_time_check) {
        return this.x_axis_g.transition().duration(1000).call(this.x_axis).selectAll("text").attr("transform", "rotate(0)");
      } else {
        return this.x_axis_g.transition().duration(1000).call(this.x_axis).selectAll("text").attr("transform", "rotate(-45)").style("text-anchor", "end").attr("dy", ".75em").attr("dx", "-.75em");
      }
    }

    clearGraphandUpdate() {
      var e;
      if (this.barInit) {
        this.grouped = false;
        $(`input[name='${this.graph_id}-${this.transition_name}']`).attr('checked', false);
        try {
          this.layer.remove();
        } catch (error) {
          e = error;
          console.log(e);
        }
      }
      this.tooltip.hideTooltip();
      return this.update();
    }

    bumpLayer(n, i) {
      var a, name, value, x;
      a = [];
      x = 0;
      while (x < n) {
        name = this.restrictedData[x].issues[i].name;
        value = this.restrictedData[x].issues[i].value;
        if (this.isInArray(name, this.stat_list)) {
          a[x] = value;
        } else {
          a[x] = 0;
        }
        x += 1;
      }
      return a.map(function(d, i) {
        return {
          x: i,
          y: d
        };
      });
    }

    transition(grouped_in) {
      var _self, numOfBars;
      _self = this;
      this.grouped = grouped_in || this.grouped;
      if (this.grouped === false) {
        this.grouped = true;
        this.y_scale.domain([0, this.yGroupMax]);
        numOfBars = this.stat_list.length;
        this.rect.transition().duration(500).delay(function(d, i) {
          return i * 10;
        }).attr('x', function(d, i, j) {
          return _self.x_scale(d.x) + _self.x_scale.rangeBand() / numOfBars * j;
        }).attr('width', _self.x_scale.rangeBand() / numOfBars).transition().attr('y', function(d) {
          return _self.y_scale(d.y);
        }).attr('height', function(d) {
          return _self.height - _self.y_scale(d.y);
        });
      } else {
        this.grouped = false;
        this.y_scale.domain([0, this.yStackMax]);
        this.rect.transition().duration(500).delay(function(d, i) {
          return i * 20;
        }).attr("y", function(d) {
          return _self.y_scale(d.y0 + d.y);
        }).attr("height", function(d) {
          return _self.y_scale(d.y0) - _self.y_scale(d.y0 + d.y);
        }).transition().attr("x", function(d) {
          return _self.x_scale(d.x);
        }).attr("width", function() {
          // console.log "@grouped == true _self.x_scale.rangeBand()"
          // console.log _self.x_scale.rangeBand()
          return _self.x_scale.rangeBand();
        });
      }
      if (!this.x_axis_var_time_check) {
        return this.x_axis_g.transition().duration(1000).call(this.x_axis).selectAll("text").attr("transform", "rotate(0)");
      } else {
        return this.x_axis_g.transition().duration(1000).call(this.x_axis).selectAll("text").attr("transform", "rotate(-45)").style("text-anchor", "end").attr("dy", ".75em").attr("dx", "-.75em");
      }
    }

    createTransitionToggle(selector) {
      var _self, checked, items, transition_id;
      _self = this;
      $(selector).empty();
      transition_id = "bar-transition";
      items = ["Grouped"];
      checked = false;
      this.createCheckList(selector, "Transition Graph", transition_id, this.transition_name, items, checked);
      return $(`input[name='${this.graph_id}-${this.transition_name}']`).on('change', function() {
        checked = $(this).is(':checked');
        return _self.transition(!checked);
      });
    }

  };

  window.BaseScatterPlot = class BaseScatterPlot extends BaseGraph {
    constructor(selector1, margin, width, height, graph_id) {
      var _self;
      super();
      this.selector = selector1;
      this.margin = margin;
      this.width = width;
      this.height = height;
      this.graph_id = graph_id;
      _self = this;
      this.tooltip = Tooltip.default(`${this.graph_id}-tooltip`, 300);
      this.colors = ["#503ABD", "#95a5a6", "#503ABD", "#2caaff", "#503ABD", "#95a5a6", "#503ABD", "#2caaff", "#503ABD", "#95a5a6", "#503ABD", "#2caaff"];
      this.y_scale = d3.scale.linear().range([this.height, 0]);
      this.x_scale = d3.scale.linear().range([0, this.width]);
      this.qcolor_scale = d3.scale.quantize().range(colorbrewer.Blues[9]);
      this.qsize_scale = d3.scale.sqrt().range([3, 20]);
      this.color_scale = function(d) {
        if (_self.isInArray(_self.chosen_color_by, _self.stat_list)) {
          return _self.qcolor_scale(d[_self.chosen_color_by]);
        } else {
          return '#845ea4';
        }
      };
      this.size_scale = function(d) {
        if (_self.isInArray(_self.chosen_size_by, _self.stat_list)) {
          return _self.qsize_scale(d[_self.chosen_size_by]);
        } else {
          return '10';
        }
      };
      this.datapoints_g = d3.select(`.transform-g-${this.graph_id}`).append("g");
      this.trendline_g = d3.select(`.transform-g-${this.graph_id}`).append("g").attr("class", `trendline-g-${this.graph_id}`);
      this.trendline_g.append("line");
      this.trendline_g.on("mouseover", function() {
        var content;
        _self.trendline.transition().duration(300).attr("stroke", "grey");
        content = '<p class="main-text"><strong>Least-Squares Regression</strong></p><hr>';
        content += '<strong>Slope</strong><span style="float: right;">' + Math.round(100 * _self.coeff[0]) / 100 + '</span></br>';
        content += '<strong>Intercept</strong><span style="float: right;">' + Math.round(100 * _self.coeff[1]) / 100 + '</span></br>';
        content += '<strong>r<sup>2</sup></strong><span style="float: right;">' + Math.round(100 * _self.coeff[2]) / 100 + '</span></br>';
        return _self.tooltip.showTooltip(content, d3.event);
      }).on("mouseout", function() {
        _self.trendline.transition().duration(300).attr("stroke", "black");
        return _self.tooltip.hideTooltip();
      });
      this.y_axis_label = this.y_axis_g.append("text").attr("transform", "rotate(-90)").attr("y", 6).attr("dy", ".71em").style("text-anchor", "end").style("font-size", "13.5px");
      this.x_axis_label = this.x_axis_g.append("text").attr("y", -16).attr("x", this.width).attr("dy", ".71em").style("text-anchor", "end").style("font-size", "13.5px");
      this.update();
    }

    update() {
      var _self, i, k, len, trendData, value, x1, x2, x_vals_after, x_vals_before, y1, y2, y_vals_after, y_vals_before;
      _self = this;
      this.active_vars = [this.chosen_x, this.chosen_y];
      this.x_scale.domain([
        0,
        d3.max(this.data,
        function(d) {
          return d[_self.chosen_x];
        })
      ]);
      this.y_scale.domain([
        0,
        d3.max(this.data,
        function(d) {
          return d[_self.chosen_y];
        })
      ]);
      if (this.isInArray(this.chosen_color_by, this.stat_list)) {
        this.qcolor_scale.domain(d3.extent(this.data, function(d) {
          return parseFloat(d[_self.chosen_color_by]);
        }));
        this.active_vars.push(this.chosen_color_by);
      }
      if (this.isInArray(this.chosen_size_by, this.stat_list)) {
        this.qsize_scale.domain(d3.extent(this.data, function(d) {
          return parseFloat(d[_self.chosen_size_by]);
        }));
        this.active_vars.push(this.chosen_size_by);
      }
      // trendline update based on Ty's code in explore.coffee
      x_vals_after = [];
      y_vals_after = [];
      x_vals_before = this.data.map(function(d) {
        return parseFloat(d[_self.chosen_x]);
      });
      y_vals_before = this.data.map(function(d) {
        return parseFloat(d[_self.chosen_y]);
      });
      if (this.data.length > 0) {
//if the chart has been initialized
        for (i = k = 0, len = x_vals_before.length; k < len; i = ++k) {
          value = x_vals_before[i];
          if (!isNaN(value) && !isNaN(y_vals_before[i])) {
            x_vals_after[i] = value;
            y_vals_after[i] = y_vals_before[i];
          }
        }
        this.coeff = this.leastSquares(x_vals_after, y_vals_after);
        x1 = this.x_scale.domain()[0];
        y1 = this.coeff[0] * this.x_scale.domain()[0] + this.coeff[1];
        x2 = this.x_scale.domain()[1];
        y2 = this.coeff[0] * this.x_scale.domain()[1] + this.coeff[1];
        trendData = [[x1, y1, x2, y2]];
        this.trendline = this.trendline_g.select("line").data(trendData);
        this.trendline.transition().duration(1000).attr("x1", function(d) {
          return _self.x_scale(d[0]);
        }).attr("y1", function(d) {
          return _self.y_scale(d[1]);
        }).attr("x2", function(d) {
          return _self.x_scale(d[2]);
        }).attr("y2", function(d) {
          return _self.y_scale(d[3]);
        }).attr("stroke", "black").attr("stroke-width", 6).style("stroke-dasharray", "16, 6");
      }
      this.datapoints = this.datapoints_g.selectAll("circle").data(this.data);
      this.datapoints.exit().remove();
      this.datapoints.enter().append("circle").attr("r", function(d) {
        return 0;
      }).attr("cx", function(d) {
        return -10;
      }).attr("cy", function(d) {
        return d[1];
      }).attr("r", 0).on("mouseover", function(d, i) {
        return _self.showDetails(d, i, _self, this);
      }).on("mouseout", function(d, i) {
        return _self.hideDetails(d, i, _self, this);
      });
      this.datapoints.transition().duration(1000).attr("cx", function(d) {
        return _self.x_scale(d[_self.chosen_x]);
      }).attr("cy", function(d) {
        return _self.y_scale(d[_self.chosen_y]);
      }).attr("r", function(d) {
        return _self.size_scale(d);
      }).attr("fill", function(d) {
        return _self.color_scale(d);
      }).attr("stroke", "#503ABD").attr("stroke-width", 1);
      this.x_axis = d3.svg.axis().scale(this.x_scale).orient("bottom");
      this.y_axis = d3.svg.axis().scale(this.y_scale).orient("left");
      this.x_axis.tickFormat(function(d, i) {
        return _self.format_number(d);
      });
      this.y_axis.tickFormat(function(d, i) {
        return _self.format_number(d);
      });
      this.y_axis_g.transition().duration(1000).call(this.y_axis);
      this.x_axis_g.transition().duration(1000).call(this.x_axis);
      return value;
    }

    changeXAxisVar(chosen_x_in) {
      this.chosen_x = chosen_x_in;
      return this.update();
    }

    changeYAxisVar(chosen_y_in) {
      this.chosen_y = chosen_y_in;
      return this.update();
    }

    changeColorBy(chosen_color_by_in) {
      this.chosen_color_by = chosen_color_by_in;
      return this.update();
    }

    changeSizeBy(chosen_size_by_in) {
      this.chosen_size_by = chosen_size_by_in;
      return this.update();
    }

    // make a trendline (or remove it) if desired
    // define a least squares function (http://bl.ocks.org/benvandyke/8459843)
    // returns slope, intercept and r-square of the line
    leastSquares(xSeries, ySeries) {
      var intercept, rSquare, reduceSumFunc, slope, ssXX, ssXY, ssYY, xBar, yBar;
      reduceSumFunc = function(prev, cur) {
        return prev + cur;
      };
      xBar = xSeries.reduce(reduceSumFunc) * 1.0 / xSeries.length;
      yBar = ySeries.reduce(reduceSumFunc) * 1.0 / ySeries.length;
      ssXX = xSeries.map(function(d) {
        return Math.pow(d - xBar, 2);
      }).reduce(reduceSumFunc);
      ssYY = ySeries.map(function(d) {
        return Math.pow(d - yBar, 2);
      }).reduce(reduceSumFunc);
      ssXY = xSeries.map(function(d, i) {
        return (d - xBar) * (ySeries[i] - yBar);
      }).reduce(reduceSumFunc);
      slope = ssXY / ssXX;
      intercept = yBar - (xBar * slope);
      rSquare = Math.pow(ssXY, 2) / (ssXX * ssYY);
      return [slope, intercept, rSquare];
    }

  };

  window.BasePieChart = class BasePieChart extends BaseGraph {
    constructor(selector1, margin, width, height, graph_id, scale_by = "count") {
      super();
      this.selector = selector1;
      this.margin = margin;
      this.width = width;
      this.height = height;
      this.graph_id = graph_id;
      this.scale_by = scale_by;
      this.radius = Math.min(this.width, this.height) / 2;
      this.pieSegmentOuterRadius = this.radius - 10;
      this.pieSegmentInnerRadius = 0;
      this.labelRadius = this.radius - 50;
      this.arc = d3.svg.arc().outerRadius(this.pieSegmentOuterRadius).innerRadius(this.pieSegmentInnerRadius);
      this.labelArc = d3.svg.arc().outerRadius(this.labelRadius).innerRadius(this.labelRadius);
      this.colors = d3.scale.ordinal().range(["#98abc5", "#8a89a6", "#7b6888", "#6b486b", "#a05d56", "#d0743c", "#ff8c00"]);
      this.pie_space = d3.select(`.transform-g-${this.graph_id}`).append("g").attr("transform", "translate(" + (this.width - this.pieSegmentOuterRadius) + "," + this.height / 2 + ")");
      this.labelGroup = d3.select(`.label-group-${this.graph_id}`);
      this.tooltip = Tooltip.default(`${this.graph_id}-tooltip`);
      this.update();
    }

    update() {
      // in the case that there is an "Other" pie wedge -- nearly always -- we want to make sure this has an id for use in selects, i.e. hover/show/hide details
      if (this.data.length > 0 && !this.data[this.data.length - 1].id) {
        this.data[this.data.length - 1]["id"] = "Other";
      }
      this.pie = d3.layout.pie().sort(null).value((d) => {
        return d[`${this.scale_by}`];
      });
      if (this.data.length > 0) {
        this.arcs_groups = this.pie_space.selectAll(".arc").data(this.pie(this.data)).enter().append("g").attr("class", "arc").attr("id", (d, i) => {
          return d.data[this.isSelectedKey];
        });
        this.arcs_groups.append("path").attr("class", "pie-chart-path").style("stroke-width", "0.25px").style("stroke", "white").on("mouseover", (d, i) => {
          return this.showDetails(d, i);
        }).on("mouseout", (d, i) => {
          return this.hideDetails(d, i);
        // transition slices one by one
        }).transition().delay((d, i) => {
          return 10 * i;
        // transition all slices together ß
        // .duration((d, i) => 100 * i)
        }).attrTween("d", (d) => {
          var i;
          i = d3.interpolate(d.startAngle + 0.1, d.endAngle);
          return (t) => {
            d.endAngle = i(t);
            return this.arc(d);
          };
        });
        return this.arcs_groups.append("text").attr("transform", (d) => {
          return "translate(" + this.labelArc.centroid(d) + ")";
        }).attr("dy", ".35em").attr("text-anchor", "middle").attr("fill", "white").text((d, i) => {
          return d.data[this.labelKey];
        });
      }
    }

    clearGraphandUpdate() {
      if (this.arcs_groups) {
        this.arcs_groups.remove();
      }
      return this.update();
    }

  };

  module.exports = {
    BasePieChart: BasePieChart,
    BaseBarGraph: BaseBarGraph
  };

}).call(globalThis);
